<template>
  <div class="customer-info main">
    <van-sticky>
      <div class="search-wrap">
        <img class="icon-search" src="@static/images/business/icon_search.png" alt="" />
        <van-search v-model="searchParams.condition" @input="search" placeholder="搜索客户姓名或手机号"> </van-search>
      </div>
      <div class="filter-wrap">
        <van-dropdown-menu active-color="#FC650B" :close-on-click-outside="false">
          <van-dropdown-item
            @change="onReferesh"
            :title-class="searchParams.orderby != null ? 'active' : ''"
            v-model="searchParams.orderby"
            :options="option1"
          />
          <van-dropdown-item
            @change="onReferesh"
            :title-class="searchParams.type != null ? 'active' : ''"
            :title="searchParams.type != null ? searchParams.text : '客户类型'"
            v-model="searchParams.type"
            :options="option2"
          />
          <van-dropdown-item
            @change="onReferesh"
            :title-class="searchParams.isSuccess != null ? 'active' : ''"
            :title="searchParams.isSuccess != null ? searchParams.text : '成交状态'"
            v-model="searchParams.isSuccess"
            :options="option3"
          />
          <van-dropdown-item ref="filterRef" :title-class="filter ? 'active more' : 'more'" title="筛选">
            <van-form ref="form">
              <div class="content">
                <van-field name="radio" label="跟进状态" class="radio-wrap">
                  <template #input>
                    <van-checkbox-group v-model="searchParams.followStatus" direction="horizontal">
                      <van-checkbox v-for="(item, followIndex) in followColumns" :key="followIndex" :name="item.key" shape="square">
                        {{ item.text }}
                      </van-checkbox>
                    </van-checkbox-group>
                  </template>
                </van-field>
                <van-field name="radio" label="托管状态" class="radio-wrap">
                  <template #input>
                    <van-radio-group v-model="searchParams.isHosting" direction="horizontal">
                      <van-radio v-for="(item, followIndex) in isHostingColumns" :key="followIndex" :name="item.key">
                        {{ item.text }}
                      </van-radio>
                    </van-radio-group>
                  </template>
                </van-field>
                <van-field name="radio" label="下次沟通时间" class="radio-wrap">
                  <template #input>
                    <van-radio-group v-model="searchParams.nextChatDateType" direction="horizontal">
                      <van-radio v-for="(item, followIndex) in nextChatDateTypeColumns" :key="followIndex" :name="item.key">
                        {{ item.text }}
                      </van-radio>
                    </van-radio-group>
                  </template>
                </van-field>
                <van-field name="radio" label="预约咨询时间" class="radio-wrap">
                  <template #input>
                    <date-item title="预约咨询时间" :obj="searchParams" startKey="bespeakStartDate" endKey="bespeakEndDate"></date-item>
                  </template>
                </van-field>
                <van-field name="radio" label="预约咨询次数" class="radio-wrap">
                  <template #input>
                    <van-radio-group v-model="searchParams.bespeakCountType" direction="horizontal">
                      <van-radio v-for="(item, followIndex) in appointmentColumns" :key="followIndex" :name="item.key">
                        {{ item.text }}
                      </van-radio>
                    </van-radio-group>
                  </template>
                </van-field>
                <van-field name="radio" label="生日" class="radio-wrap">
                  <template #input>
                    <van-radio-group v-model="searchParams.birthDateType" direction="horizontal">
                      <van-radio v-for="(item, followIndex) in birthDateTypeColumns" :key="followIndex" :name="item.key">
                        {{ item.text }}
                      </van-radio>
                    </van-radio-group>
                  </template>
                </van-field>
                <van-field name="radio" label="客户来源" class="radio-wrap">
                  <template #input>
                    <van-checkbox-group v-model="searchParams.source" direction="horizontal">
                      <van-checkbox v-for="(item, followIndex) in sourceColumns" :key="followIndex" :name="item.key" shape="square">
                        {{ item.text }}
                      </van-checkbox>
                    </van-checkbox-group>
                  </template>
                </van-field>
              </div>
              <div class="btn-wrap">
                <span @click="reset"> 重置 </span>
                <span @click="onConfirm"> 确定 </span>
              </div>
            </van-form>
          </van-dropdown-item>
        </van-dropdown-menu>
      </div>
    </van-sticky>
    <van-loading v-if="isSearch" size="24px" vertical>加载中...</van-loading>
    <div v-if="list && list.length && searchParams.orderby == 1" class="customer-list">
      <van-index-bar :index-list="indexList" :sticky="false">
        <div v-for="(key, keyIndex) in indexList" :key="keyIndex">
          <van-index-anchor class="title-box" :index="key">{{ key }}</van-index-anchor>
          <div class="customer-wrap">
            <div v-for="(item, itemIndex) in customerListMap[key]" class="customer-box" :key="itemIndex" @click="goDetail(item)">
              <div class="box">
                <img v-if="item.icon" :src="item.icon" alt="" class="customer-head" />
                <img v-else-if="item.sex == 1" class="customer-head" src="@static/images/business/header_1.png" />
                <img v-else-if="item.sex == 2" class="customer-head" src="@static/images/business/header_2.png" />
                <img v-else class="customer-head" src="@static/images/business/head_default.png" />
                <div class="right-wrap">
                  <div class="name-wrap">
                    <span class="name">{{ item.name }}</span>
                    <img v-if="item.sex == 1" class="icon-sex" src="@static/images/business/icon_sex_2.png" />
                    <img v-else-if="item.sex == 2" class="icon-sex" src="@static/images/business/icon_sex_1.png" />
                    <span v-if="item.type == 2" class="label">自有</span>
                    <span v-else-if="item.type == 1" class="label yuyue">预约</span>
                  </div>
                  <div class="">
                    <span class="phone">{{ item.mobile }}</span>
                  </div>
                </div>
              </div>
              <div class="tags-box">
                <div class="tag-item" v-for="(tags, index) in item.tags && JSON.parse(item.tags)" :key="index" v-show="index < 4">{{ tags }}</div>
              </div>
              <span v-if="FOLLOW_STATUS[item.followStatus]" class="label-status">{{ FOLLOW_STATUS[item.followStatus] }}</span>
              <div class="icon-wrap">
                <span v-if="item.isBirth == 1" v-html="item.showBirthdayDate"></span>
                <img v-if="item.isCommunicate == 1" class="icon-notice" src="@static/images/business/icon_notice.png" />
                <img v-if="item.isBirth == 1" @click.stop="goMaterial(item)" class="icon-notice" src="@static/images/business/cake.gif" />
              </div>
              <p v-if="item.isSuccess == 0 && item.consultNum" class="status">
                <span class="success">预约</span><span orange>{{ item.consultNum }}</span
                ><span class="success">次</span>&nbsp;暂未成交
              </p>
              <p v-else-if="item.isSuccess == 0 && !item.consultNum" class="status">暂未预约咨询&nbsp;暂未成交</p>
              <p v-else-if="item.isSuccess == 1 && item.consultNum" class="status success">
                预约<span orange>{{ item.consultNum }}</span
                ><span class="status success">次</span>&nbsp;成交<span orange>{{ item.successNum }}</span
                >单&nbsp;&nbsp;累计保费<span orange>{{ item.successFee }}</span
                >元
              </p>
              <p v-else-if="item.isSuccess == 1 && !item.consultNum" class="status">
                暂未预约咨询&nbsp;成交<span orange>{{ item.successNum }}</span
                >单&nbsp;&nbsp;累计保费<span orange>{{ item.successFee }}</span
                >元
              </p>
            </div>
          </div>
        </div>
      </van-index-bar>
      <p class="total">共有{{ total }}名客户</p>
    </div>
    <div v-else-if="list && list.length && searchParams.orderby != 1" class="customer-list">
      <div class="customer-wrap">
        <div v-for="(item, itemIndex) in list" class="customer-box" @click="goDetail(item)" :key="itemIndex">
          <div class="box">
            <img v-if="item.icon" :src="item.icon" alt="" class="customer-head" />
            <img v-else-if="item.sex == 1" class="customer-head" src="@static/images/business/header_1.png" />
            <img v-else-if="item.sex == 2" class="customer-head" src="@static/images/business/header_2.png" />
            <img v-else class="customer-head" src="@static/images/business/head_default.png" />
            <div class="right-wrap">
              <div class="name-wrap">
                <span class="name">{{ item.name }}</span>
                <img v-if="item.sex == 1" class="icon-sex" src="@static/images/business/icon_sex_2.png" />
                <img v-else-if="item.sex == 2" class="icon-sex" src="@static/images/business/icon_sex_1.png" />
                <span v-if="item.type == 2" class="label">自有</span>
                <span v-else-if="item.type == 1" class="label yuyue">预约</span>
              </div>
              <div class="">
                <span class="phone">{{ item.mobile }}</span>
              </div>
            </div>
          </div>
          <div class="tags-box">
            <div class="tag-item" v-for="(tags, index) in item.tags && JSON.parse(item.tags)" :key="index" v-show="index < 4">
              {{ tags }}
            </div>
          </div>
          <span v-if="FOLLOW_STATUS[item.followStatus]" class="label-status">{{ FOLLOW_STATUS[item.followStatus] }}</span>
          <img v-if="item.isCommunicate == 1" class="icon-notice" src="@static/images/business/icon_notice.png" />
          <p v-if="item.isSuccess == 0 && item.consultNum" class="status">
            <span class="success">预约</span><span orange>{{ item.consultNum }}</span
            ><span class="success">次</span>&nbsp;暂未成交
          </p>
          <p v-else-if="item.isSuccess == 0 && !item.consultNum" class="status">暂未预约咨询&nbsp;暂未成交</p>
          <p v-else-if="item.isSuccess == 1 && item.consultNum" class="status success">
            预约<span orange>{{ item.consultNum }}</span
            ><span class="status success">次</span>&nbsp;成交<span orange>{{ item.successNum }}</span
            >单&nbsp;&nbsp;累计保费<span orange>{{ item.successFee }}</span
            >元
          </p>
          <p v-else-if="item.isSuccess == 1 && !item.consultNum" class="status">
            暂未预约咨询&nbsp;成交<span orange>{{ item.successNum }}</span
            >单&nbsp;&nbsp;累计保费<span orange>{{ item.successFee }}</span
            >元
          </p>
        </div>
      </div>
      <p class="total">共有{{ total }}名客户</p>
    </div>
    <div v-else-if="list.length == 0 && !isSearch" class="empty-box">
      <img src="@static/images/business/empty_2.png" alt="" />
      <p>暂无客户</p>
    </div>
    <div class="footer">
      <van-popover v-if="$config.isApp" v-model="showPopover" @select="onSelect" theme="dark" trigger="click" :actions="actions" placement="top">
        <template #reference>
          <div class="btn-add ok-bgcolor"><img src="@static/images/business/icon_add.png" />新建客户</div>
        </template>
      </van-popover>
      <div v-else class="btn-add ok-bgcolor" @click="onSelect({ type: 1 })"><img src="@static/images/business/icon_add.png" />新建客户</div>
    </div>
  </div>
</template>
<script>
var timer;
import { loading, common } from '@/api/mixins';
import dateItem from './dateItem';
import dayjs from 'dayjs';
export default {
  components: { dateItem },
  mixins: [loading, common],
  computed: {
    filter() {
      let arr = ['orderby', 'type', 'isSuccess', 'pageSize', 'pageNo'];
      let tmp = false;
      for (let key in this.searchParams) {
        if (this.searchParams[key] != null && this.searchParams[key].length > 0 && arr.indexOf(key) == -1) {
          tmp = true;
        }
      }
      return tmp;
    }
  },
  data() {
    return {
      isSearch: false,
      list: [],
      customerListMap: {},
      sDate: '',
      eDate: '',
      refreshing: false, //下拉刷新
      finished: true, //是否完成上拉加载
      searchParams: {
        //列表查询参数
        orderby: '1', //排序方式,@notes1-姓名正序2-沟通时间倒序
        type: null, //客户类型,@notes1-预约2-自有
        isSuccess: null, //成交状态,@notes0-未成交1-已成交
        pageSize: 10,
        pageNo: 1,
        condition: '', //搜索内容
        isHosting: '', //托管状态
        followStatus: [], //跟进状态
        birthDateType: '', //生日
        nextChatDateType: '', //下次沟通过时间
        source: [] //客户来源
      },
      totalNo: '', //总页数
      total: '',
      showPopover: false,
      actions: [
        {
          text: '手动添加',
          type: 1
        },
        {
          text: '通讯录导入',
          type: 2
        }
      ],
      status: {
        0: '待跟进',
        1: '跟进中',
        2: '已成交',
        3: '未促成',
        4: '暂时放弃',
        5: '无效记录'
      },
      indexList: [],
      option1: [
        {
          text: '按姓名正序',
          value: '1'
        },
        {
          text: '按最新沟通时间',
          value: '2'
        },
        {
          text: '预约次数',
          value: '3'
        },
        {
          text: '最新预约时间',
          value: '4'
        }
      ],
      option2: [
        {
          text: '全部客户',
          value: null
        },
        {
          text: '预约客户',
          value: 1
        },
        {
          text: '自有客户',
          value: 2
        }
      ],
      option3: [
        {
          text: '全部',
          value: null
        },
        {
          text: '未成交',
          value: 0
        },
        {
          text: '已成交',
          value: 1
        }
      ],
      FOLLOW_STATUS: {},
      followColumns: [],
      sourceColumns: [],
      isHostingColumns: [
        {
          text: '全部',
          key: ''
        },
        {
          text: '已托管',
          key: '1'
        },
        {
          text: '未托管',
          key: '0'
        }
      ],
      birthDateTypeColumns: [
        {
          text: '全部',
          key: ''
        },
        {
          text: '近一个月',
          key: '1'
        },
        {
          text: '近半个月',
          key: '2'
        },
        {
          text: '近7天',
          key: '3'
        }
      ],
      nextChatDateTypeColumns: [
        {
          text: '全部',
          key: ''
        },
        {
          text: '近半个月',
          key: '2'
        },
        {
          text: '近7天',
          key: '3'
        },
        {
          text: '近2天',
          key: '4'
        }
      ],
      appointmentColumns: [
        {
          text: '全部',
          key: ''
        },
        {
          text: '未咨询',
          key: '0'
        },
        {
          text: '咨询1次',
          key: '1'
        },
        {
          text: '咨询多次',
          key: '2'
        },
        {
          text: '大于0次',
          key: '3'
        }
      ],
      userinfo: {}
    };
  },
  created() {
    try {
      this.userinfo = JSON.parse(localStorage.jzy_user);
      console.log(this.userinfo);
    } catch (error) {
      console.log(error);
    }
    this.$http({
      url: '/app/customer/querySourceList',
      type: 'POST',
      data: {}
    }).then(res => {
      this.sourceColumns = res.data.map(item => {
        return {
          text: item.name,
          key: item.code
        };
      });
    });
    this.getDicByType({
      type: 'FOLLOW_STATUS'
    }).then(res => {
      this.FOLLOW_STATUS = res;
      for (let key in res) {
        //跟进状态
        this.followColumns.push({
          text: res[key],
          key
        });
      }
    });
  },
  methods: {
    search(data = {}) {
      let { type, birthDateType } = data;
      if (type == 1) {
        //预约客户
        this.searchParams.type = 1;
      } else if (type == 2) {
        //自有客户
        this.searchParams.type = 2;
      } else if (type == 3) {
        //成交客户
        this.searchParams.isSuccess = 1;
      } else if (type == 4) {
        //近两天沟通客户
        this.searchParams.nextChatDateType = '4';
      }
      if (birthDateType) {
        this.searchParams.birthDateType = birthDateType;
      }
      this.isSearch = true;
      setTimeout(() => {
        this.getList(false);
      }, 500);
    },
    // 选择时间
    selectDate(date) {
      this.sDate = date[0];
      this.eDate = date[1];
    },
    goMaterial(item) {
      sessionStorage.removeItem('materialActiveNum');
      sessionStorage.removeItem('materialActiveIndex');
      this.$router.push({
        name: 'apps.newMaterial',
        query: {
          userId: this.userinfo.id,
          code: 'birthday'
        }
      });
    },
    goDetail(item) {
      sessionStorage.setItem('okbaocustomerIdx', 2);
      this.$router.push({
        path: '/apps/business/customerDetail',
        query: {
          id: item.id
        }
      });
    },
    reset() {
      this.$refs.filterRef.toggle();
      let keys = ['orderby', 'pageSize', 'pageNo', 'isSuccess', 'type', 'condition'];
      for (let key in this.searchParams) {
        if (keys.indexOf(key) == -1) {
          if (key == 'followStatus' || key == 'source') {
            this.searchParams[key] = [];
          } else {
            this.searchParams[key] = '';
          }
        }
      }
      this.onReferesh();
    },
    onConfirm() {
      this.$refs.filterRef.toggle();
      this.onReferesh();
    },
    onSelect(res) {
      let vm = this;
      if (res.type === 1) {
        //手动添加客户
        this.$router.push({
          path: '/apps/okbao/addCustomer'
        });
      } else {
        //通讯录导入
        if (this.$config.isApp) {
          this.$app.getAddressBook(
            res => {
              if (typeof res == 'string') {
                try {
                  res = JSON.parse(res);
                } catch (error) {}
              }
              vm.mobileImport(res);
            },
            err => {
              vm.$notice.msg(err);
            }
          );
        }
      }
    },
    mobileImport(list) {
      let loadings = this.$notice.loading('正在导入通讯录');
      this.$http({
        type: 'POST',
        url: '/app/customer/queryImport',
        data: list
      })
        .then(res => {
          this.$notice.close(loadings);
          sessionStorage.setItem('ADDRESS_BOOK_CUSTOMER_LIST', JSON.stringify(res.data));
          this.$router.push({
            path: '/apps/business/importCustomer'
          });
        })
        .catch(res => {
          this.$notice.msg(res.msg);
          this.$notice.close(loadings);
        });
    },
    //上拉加载
    nextPage() {
      if (this.searchParams.pageNo == this.totalNo) {
        this.finished = true;
        return;
      }
      this.searchParams.pageNo++;
      this.getList(false);
    },
    search() {
      this.isSearch = true;
      this.loading = loading;
      this.list = [];
      clearTimeout(timer);
      timer = setTimeout(() => {
        this.onReferesh();
      }, 1000);
    },
    //下拉刷新
    onReferesh() {
      this.refreshing = true;
      this.searchParams.pageNo = 1;
      this.list = [];
      this.getList(true);
    },
    getList(loading = false) {
      this.loading = loading;
      this.$http({
        type: 'POST',
        url: '/app/customer/myCustomerList',
        data: {
          ...this.searchParams,
          followStatus: this.searchParams.followStatus.join(),
          source: this.searchParams.source.join()
        }
      })
        .then(res => {
          this.searchParams.pageNo = res.current;
          this.totalNo = res.pages;
          this.total = res.total;
          if (res.current == 1) {
            this.list = [];
            this.customerListMap = {};
            this.indexList = [];
          }
          res.data.map(item => {
            if (item.birthDate && item.isBirth == 1) {
              if (dayjs(item.birthDate).format('MM-DD') == dayjs().format('MM-DD')) {
                item.showBirthdayDate = '<span orange>' + '今天生日' + '</span>';
              } else if (dayjs(item.birthDate).format('MM') == dayjs().format('MM')) {
                item.showBirthdayDate = '本月' + '<span orange>' + parseInt(dayjs(item.birthDate).format('DD')) + '号' + '</span>' + '生日';
              } else {
                let month = '下月';
                if (parseInt(dayjs(item.birthDate).format('MM')) - parseInt(dayjs().format('MM')) != 1) {
                  month = parseInt(dayjs(item.birthDate).format('MM')) + '月';
                }
                item.showBirthdayDate = month + '<span orange>' + parseInt(dayjs(item.birthDate).format('DD')) + '号' + '</span>' + '生日';
              }
            }
          });
          this.list = [...this.list, ...res.data].map(item => {
            let key = item.nameFirst.substr(0, 1);
            if (this.indexList.indexOf(key) == -1) {
              this.indexList = [...this.indexList, key];
            }
            if (this.customerListMap[key]) {
              this.customerListMap[key] = [...this.customerListMap[key], item];
            } else {
              this.customerListMap[key] = [item];
            }
            return {
              ...item,
              firstKey: key
            };
          });
          this.refreshing = false;
          this.loading = false;
          this.isSearch = false;
          if (res.current === res.pages) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        })
        .catch(() => {
          this.isSearch = false;
          this.loading = false;
          this.refreshing = false;
          this.finished = true;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import './customer.scss';
</style>
